import $ from 'jquery'

window._ = require('lodash');
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = $;
    require('bootstrap');
} catch (e) {
}
